import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const ProfileBoxTitleMargin = styled.span`
  margin-bottom: ${({ theme }) => theme.spacing.x2};
  font-size: ${({ theme }) => theme.fs.md};
`;
export const ProfileBoxTitle = styled.span`
  font-size: ${({ theme }) => theme.fs.md};
`;
export const ProfileMilage = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const ParntNumberInput = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserCodeType = styled.div`
  margin-top: 5px;
  display: flex;
  gap: 3px;
`;

export const UserInfoField = styled.div`
  flex-grow: 1;
`;

export const LabelAutocomplete = styled.label`
  color: #97a3ba;
  font-size: 12px;
  display: flex;
`;

// TODO dont add style to textField component
export const TextField = styled.div`
  div {
    flex-grow: 1 !important;
  }
`;

export const ParentBtns = styled.div`
  flex-shrink: 0;
  margin-inline: ${({ theme }) => theme.spacing.x2};
  margin-top: ${({ theme }) => theme.spacing.x5};
`;

export const ProfileCard = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: 10px;
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x5}`};
  margin-bottom: ${({ theme }) => theme.spacing.x4};

  @media (max-width: ${({ theme }) => theme.media.sm}) {
    form {
      font-size: ${({ theme }) => theme.fs.xxs};
    }

    input {
      width: 100%;
    }
    label {
      white-space: nowrap;
    }
  }
`;
export const ProfileHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  margin-bottom: ${({ theme }) => theme.spacing.x2};
`;
export const ParentCancleAndDef = styled.div`
  display: flex;
  align-items: center;
`;

export const FormAnnouncement = styled.p`
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.error};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const ProfileCardBtn = styled.button`
  font-size: ${({ theme }) => theme.fs.xs};
  background: ${({ theme }) => theme.palette.secondary};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.white};
  height: ${({ theme }) => theme.spacing.x8};
  outline: none;
  border: none;
  cursor: pointer;
  transition: 0.2s;
  font-weight: bold;
  &:hover {
    background: #417aee;
  }
`;
export const ProfileCardBtnSvg = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.x2};
`;
export const ProfileCardBtnNbg = styled.button`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.secondary};
  height: ${({ theme }) => theme.spacing.x8};
  outline: none;
  border: none;
  cursor: pointer;
  transition: 0.2s;
  font-weight: bold;
  margin-left: auto;
  &:hover {
    background: #f2f2f2;
  }
`;

const InputWrapper = styled.div`
  margin: -${({ theme }) => theme.spacing.x2};
  display: flex;
  flex-wrap: wrap;
`;

export const ProfileFormInputWrapper = styled(InputWrapper)`
  > * {
    padding: ${({ theme }) => theme.spacing.x2};
    width: 33.333%;
    @media (max-width: ${({ theme }) => theme.media.sm}) {
      width: 50%;
    }
    @media (max-width: ${({ theme }) => theme.media.xs}) {
      width: 100%;
    }
  }
`;
export const UserInfoFormInputWrapper = styled(InputWrapper)`
  > * {
    padding: ${({ theme }) => theme.spacing.x2};
    width: 50%;
    @media (max-width: ${({ theme }) => theme.media.sm}) {
      width: 100%;
    }
  }
`;

export const PasswordFormInputWrapper = styled(InputWrapper)`
  > * {
    padding: ${({ theme }) => theme.spacing.x2};
    width: 33.333%;
    @media (max-width: ${({ theme }) => theme.media.sm}) {
      width: 100%;
    }
  }
`;

export const ChangePasswordtWrapper = styled(InputWrapper)`
  > * {
    padding: ${({ theme }) => theme.spacing.x2};
    width: 50%;
    @media (max-width: ${({ theme }) => theme.media.sm}) {
      width: 100%;
    }
  }
`;

export const ProfileCardBtnNbgSvg = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.x2};
`;
export const ProfileCardBtnCancleAuto = styled.button`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: ${({ theme }) => theme.rounded.x1};
  color: ${({ theme }) => theme.palette.secondary};
  border: 1px solid ${({ theme }) => theme.palette.secondary};
  height: ${({ theme }) => theme.spacing.x8};
  outline: none;
  cursor: pointer;
  transition: 0.2s;
  font-weight: bold;
  margin-left: auto;
  &:hover {
    background: ${({ theme }) => theme.palette.secondary};
    color: ${({ theme }) => theme.palette.white};
  }
`;
export const ProfileCardBtnCancle = styled.button`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: ${({ theme }) => theme.rounded.x1};
  color: ${({ theme }) => theme.palette.secondary};
  border: 1px solid ${({ theme }) => theme.palette.secondary};
  height: ${({ theme }) => theme.spacing.x8};
  outline: none;
  cursor: pointer;
  transition: 0.2s;
  font-weight: bold;
  &:hover {
    background: ${({ theme }) => theme.palette.secondary};
    color: ${({ theme }) => theme.palette.white};
  }
  margin-inline-start: ${({ theme }) => theme.spacing.x2};
`;
export const ProfileCardBtndefult = styled.button`
  margin-inline-start: ${({ theme }) => theme.spacing.x2};
`;
export const ProfileCardBtnchange = styled.button`
  /* margin-left: auto; */
  margin-inline-start: ${({ theme }) => theme.spacing.x2};
`;
export const TextFieldProfile = styled.div`
  width: 50% !important;
`;

export const ButtonWrapper = styled.div`
  margin-inline-start: 0px !important;
`;

export const Button = styled.div`
  width: 147px;

  @media (max-width: ${({ theme }) => theme.media.xs}) {
    width: 100%;
  }
`;
